import { Button, Popconfirm, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { DataType } from ".";

interface ColumnActions {
  handleEdit: (record: DataType) => void;
  handleDelete: (id: number) => void;
}

export const currencyColumns = (actions?: ColumnActions): ColumnsType<DataType> => [
  {
    title: "ID",
    dataIndex: "id",
    sorter: false,
    width: "10%",
  },
  {
    title: "Nombre",
    dataIndex: "name",
    sorter: false,
    width: "10%",
  },
  {
    title: "Codigo",
    dataIndex: "code",
    sorter: false,
    width: "10%",
  },
  {
    title: "Base",
    dataIndex: "base",
    sorter: false,
    width: "10%",
  },
  {
    title: "Tasa Oficial",
    dataIndex: "rate",
    sorter: false,
    width: "10%",
  },
  {
    title: "Spread",
    dataIndex: "spread",
    sorter: false,
    width: "10%",
    render: (spread: number) => (spread ? `+${spread}` : "-"),
  },
  {
    title: "Tasa Final",
    dataIndex: "displayRate",
    sorter: false,
    width: "10%",
  },
  {
    title: "Acciones",
    width: "15%",
    render: (_: any, record: DataType) => (
      <Space>
        <Button type="link" icon={<EditOutlined />} onClick={() => actions?.handleEdit(record)} />
        <Popconfirm title="¿Eliminar moneda?" onConfirm={() => actions?.handleDelete(record.id)}>
          <Button type="link" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    ),
  },
];
